module.exports = __webpack_public_path__ + "static/media/job-matcher-in-progress-premium-no-bg.9d5e5cab.svg";